import { render, staticRenderFns } from "./SizeCategoryList.vue?vue&type=template&id=7f3283c6&scoped=true"
import script from "./SizeCategoryList.vue?vue&type=script&lang=js"
export * from "./SizeCategoryList.vue?vue&type=script&lang=js"
import style0 from "./SizeCategoryList.vue?vue&type=style&index=0&id=7f3283c6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3283c6",
  null
  
)

export default component.exports